<template>
    <div :class="['widget-form', {'widget-form--disabled': disabled}]">
        <div class="widget-form__title">{{ title }}</div>

        <div class="widget-form__content">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'widget-form',
    props: {
        title: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.widget-form {
    padding: 0 2rem 4rem;
    color: $blue-charcoal-color;

    &--disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    &__title {
        font-size: 1.7rem;
        line-height: 2.7rem;
        font-weight: 700;
        color: $cyprus-color;
        padding-bottom: 1rem;

        @include min-width(lg) {
            font-size: 2rem;
        }
    }

    &__content {
        width: auto;
        flex-wrap: wrap;
        display: flex;
        background: $white-color;
        box-shadow: none;
        justify-content: space-between;
        padding: 3.3rem 1.9rem 3rem 2.5rem;
        border-radius: 1rem;
        flex-direction: column;

        @include min-width(lg) {
            align-items: flex-start;
            flex-direction: row;
            padding: 3.3rem 3.9rem 3.8rem 4.5rem;
        }
    }
}
</style>